class BannerWithTextAnimation extends HTMLElement {
  constructor() {
    super();

    this.isMobile = window.innerWidth <= 990;
    this.handleResize = this.handleResize.bind(this);
    this.swiperInstance = null;
    this.initializedMode = null;
  }

  connectedCallback() {
    this.initialize();
    window.addEventListener('resize', this.handleResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
  }

  initialize() {
    const isMobile = window.innerWidth <= 990;

    if (this.initializedMode === (isMobile ? 'mobile' : 'desktop')) return;

    this.initializedMode = isMobile ? 'mobile' : 'desktop';

    if (isMobile) {
      this.initSwiper();
    } else {
      this.initTextHoverImageSwap();
    }
  }

  handleResize() {
    const isMobile = window.innerWidth <= 990;

    if (isMobile && this.initializedMode !== 'mobile') {
      this.destroySwiper();
      this.initialize();
    } else if (!isMobile && this.initializedMode !== 'desktop') {
      this.initialize();
    }
  }

  initSwiper() {
    const slider = this.querySelector('.banner-text-animation-slider');
    if (!slider) return;

    this.swiperInstance = new Swiper(slider, {
      slidesPerView: 1,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  }

  destroySwiper() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }

  initTextHoverImageSwap() {
    const texts = this.querySelectorAll('.text-item');
    const images = this.querySelectorAll('.image-container');

    texts.forEach(text => {
      text.addEventListener('mouseenter', () => {
        texts.forEach(t => t.classList.remove('text-item--active'));
        images.forEach(img => img.classList.remove('image-container--active'));

        text.classList.add('text-item--active');
        const imgId = text.getAttribute('data-image');
        const targetImage = this.querySelector(`#${imgId}`);
        if (targetImage) targetImage.classList.add('image-container--active');
      });
    });
  }
}

customElements.define('banner-text-animation', BannerWithTextAnimation);
